
import { translations, eventHandler } from "@/mixins";
import Translations from "./Translations.vue";
import { Component, Prop, Vue, Watch, Ref } from "vue-property-decorator";
import { Location } from "@/services/SOLO";

@Component({
  components: {
    Translations,
  },
  mixins: [translations, eventHandler],
})
export default class TemporaryDeliveryModal extends Vue {
  @Prop() location!: any;
  public open: boolean = false;
  distance: any = null;

  $notify: any;
  translate!: Function;

  @Watch('open', { immediate: true, deep: true })
  onOpen(value: Boolean) {
    if(!value) {
      this.open = false;
    }
  }

  close() {
    this.open = false;
  }

  async handleCreateTemporaryDeliveryZone() {
    if (this.distance <= 0) return;

    try {
      const points = await this.getDeliveryZonePoints(this.location.attributes, this.distance);
      if (!points || points.length === 0) {
        throw new Error("Invalid delivery zone points.");
      }

      const payload = {
        coordinates: points,
        label: `Temporary ${this.distance}km`,
      };

      await Location.createArea(payload, this.location.id);
      
      this.close();
      this.distance = null;
      this.$emit('prepareMapForAddingNewDeliveryArea', this.location);
      this.$notify({
        title: this.translate("SUCCESS!"),
        verticalAlign: "bottom",
        horizontalAlign: "left",
        message: "Delivery Zone Created Successfully.",
        type: "success",
        icon: "fas fa-check",
      });
    } catch (err) {
      const errorMessage = err?.response?.data?.error?.[0]?.detail || "An unexpected error occurred.";
      this.$notify({
        title: this.translate("SYSTEM ERROR!"),
        verticalAlign: "bottom",
        horizontalAlign: "left",
        message: errorMessage,
        type: "danger",
        icon: "fas fa-bomb",
      });
    }
  }

/**
 * Just in-case you need to use this old method
  getDeliveryZonePoints(location: any, radius: any) {
      let points = [];
      let spherical = google.maps.geometry.spherical;
      let point = new google.maps.LatLng(location.lat, location.long);
      let angles = [0, 45, 90, 135, 180, 225, -90, -45];
      for (let a of angles) {
          let p = spherical.computeOffset(point, radius * 1000, a);
          points.push([p.lat(), p.lng()]);
      }
      return points;
  }
 */

  getDeliveryZonePoints(location: any, radius: number, totalPoints: number = 20) {
    if (!location?.lat || !location?.long || radius <= 0) {
      console.error("Invalid location or radius");
      return [];
    }

    const points = [];
    const spherical = google.maps.geometry.spherical;
    const centerPoint = new google.maps.LatLng(location.lat, location.long);
    /** This angleStep, we are getting the equal distance from one angle to another as we are forming a polygon/full circle as delivery zone  */
    const angleStep = 360 / totalPoints;

    /** Same logic from the old function, we are forming a polygon as a delivery zone of the store
     * by getting the points from the center point and the radius of the delivery zone. 
     * 
     * This totalPoints is the total sides of the area, More points for a smoother circle */
    for (let point = 0; point < totalPoints; point++) {
      const angle = point * angleStep;
      const p = spherical.computeOffset(centerPoint, radius * 1000, angle);
      points.push([p.lat(), p.lng()]);
    }

    /** Ensure the first and last point are the same to close the polygon */
    points.push(points[0]);

    return points;
  }
}
